// Page hero, in two variants:
//
// - default: a sharp full-bleed photograph with a legibility scrim. Only
//   /images/bg.jpg (3456x2304) is large enough for this, so in practice it is
//   the home page. `tall` makes it near-full-viewport and centred.
// - `plain`: a light typographic hero with no photograph. Every other image in
//   the repo is a 448x336 thumbnail, and there is no way to fill a hero with
//   one that does not look broken, so inner pages use this and show their photo
//   at native size further down the page.
const Hero = ({
  kicker,
  heading,
  tagline,
  image = '/images/bg.jpg',
  tall = false,
  plain = false,
  children,
}) => (
  <header
    className={`hero${tall ? ' hero--tall' : ''}${plain ? ' hero--plain' : ''}`}
    role="banner"
  >
    {!plain && (
      <div
        className="hero__media"
        style={{ backgroundImage: `url(${image})` }}
      />
    )}
    <div className="hero__inner container">
      {kicker && <p className="hero__kicker">{kicker}</p>}
      <h1>{heading}</h1>
      {tagline && <p className="hero__tagline">{tagline}</p>}
      {children}
    </div>
  </header>
);

export default Hero;
